(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('.tkb-nav').forEach((nav) => {
      if (nav.dataset.tkbSubnavReady) return;
      nav.dataset.tkbSubnavReady = 'true';
      const toggles = Array.from(nav.querySelectorAll('[data-tkb-subnav-toggle]'));
      const panelFor = (button) => document.getElementById(button.getAttribute('aria-controls'));
      const closeAll = (except = null) => toggles.forEach((button) => {
        if (button === except) return;
        button.setAttribute('aria-expanded', 'false');
        const panel = panelFor(button); if (panel) panel.hidden = true;
      });
      toggles.forEach((button) => button.addEventListener('click', () => {
        const panel = panelFor(button); if (!panel) return;
        const opening = button.getAttribute('aria-expanded') !== 'true';
        closeAll(button);
        button.setAttribute('aria-expanded', String(opening)); panel.hidden = !opening;
      }));
      nav.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = toggles.find((button) => button.getAttribute('aria-expanded') === 'true');
        if (!open) return;
        event.preventDefault(); event.stopPropagation(); closeAll(); open.focus();
      }, true);
      nav.addEventListener('click', (event) => { if (event.target.closest('a')) closeAll(); });
      nav.addEventListener('focusout', () => setTimeout(() => {
        if (!nav.contains(document.activeElement)) closeAll();
      }, 0));
      document.addEventListener('click', (event) => { if (!nav.contains(event.target)) closeAll(); });
      const breakpoint = window.matchMedia('(max-width:1280px)');
      if (breakpoint.addEventListener) breakpoint.addEventListener('change', () => closeAll());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
